export default __webpack_public_path__ + "static/media/agua.d3fc6b30.png";